import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { shallow } from 'zustand/shallow';

import AdminApp from './containers/AdminApp';
import AthleteApp from './containers/AthleteApp';
import Auth from './components/Auth';
import MarketingHome from './pages/Marketing/Home';
import MarketingFounders from './pages/Marketing/Founders';
import appStore from '@duck/app-store';
import { attachServerSessionToken } from '@util/axiosDefaults';
import { setSentryUserFromStore } from '@util/sentry';

export default function App() {
  const isApplicationPath =
    window.location.pathname === '/app' ||
    window.location.pathname.startsWith('/app/');

  if (!isApplicationPath) {
    return (
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<MarketingHome />} />
          <Route path="/the-founders" element={<MarketingFounders />} />
          <Route path="*" element={<MarketingHome />} />
        </Routes>
      </BrowserRouter>
    );
  }

  return (
    <BrowserRouter basename="/app">
      <Toaster />
      <TrackerApplication />
    </BrowserRouter>
  );
}

function TrackerApplication() {
  const [loading, setLoading] = useState(true);
  const { admin, athlete, setAdmin, setAthlete } = appStore(
    (state) => ({
      admin: state.admin,
      athlete: state.athlete,
      setAdmin: state.setAdmin,
      setAthlete: state.setAthlete,
    }),
    shallow,
  );

  useEffect(() => {
    axios
      .get(`/status/`)
      .then(({ data }) => {
        const session = data.response && data.response[0];

        if (session && session.server_session_token) {
          attachServerSessionToken(session.server_session_token);
        }

        if (session && session.admin_id) {
          setAdmin(session);
          setSentryUserFromStore();
          return;
        }

        if (session && session.athlete_id) {
          setAthlete(session);
          setSentryUserFromStore();
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }, [setAdmin, setAthlete]);

  if (loading) {
    return null;
  }

  return <AppRoutes admin={admin} athlete={athlete} />;
}

function AppRoutes({ admin, athlete }) {
  const location = useLocation();

  if (admin) {
    return <AdminApp />;
  }

  if (athlete) {
    return <AthleteApp />;
  }

  return (
    <div style={{ minHeight: '100vh', height: '100%' }}>
      <Auth key={location.pathname} />
    </div>
  );
}
